export const frOperations = {
    // OPERATIONS

    'operations.type.operation': 'Plan de vente',
    'operations.type.engagement': 'Engagement',
    'operations.type.unknown': 'Inconnu',

    // OPERATIONS >> LIST

    'operations.list.pageTitle': 'Plans de vente',
    'operations.title': 'Plans de vente',
    'operations.list.sectionTitle': 'Plans de vente',

    'operations.list.actions.addOperation': 'Créer un plan de vente',
    'operations.list.actions.addEngagement': 'Créer un engagement',

    'operations.list.table.header.info': 'Informations',
    'operations.list.table.header.owner': 'Propriétaire',
    'operations.list.table.header.nbShops': 'Nombre de centres',
    'operations.list.table.header.endDate': "Date d'échéance",
    'operations.list.table.header.type': 'Type',

    'operations.list.emptyLabel': 'Aucun plan de vente pour le moment.',
    'operations.list.table.emptyLabel': "Il n'y a pas de plan de vente pour le moment.",
    'operations.list.table.state.draft': 'Brouillon',
    'operations.list.table.state.drafts': 'Brouillon',
    'operations.list.table.state.published': 'Publié',
    'operations.list.table.state.unpublished': 'Annulé',
    'operations.list.table.state.finished': 'Terminé',
    'operations.list.table.filters.favoriteShops': 'Mes centres favoris',
    'operations.list.table.filters.apply': 'Appliquer',
    'operations.list.table.filters.label.state': 'État :',

    // OPERATIONS > DETAILS

    'operations.operation.details.pageTitle': 'Détails plan de vente',
    'operations.engagement.details.pageTitle': 'Détails engagement',
    'operations.details.actions.previous': 'Plans de vente',
    'operations.info.operationStartDate.label': 'Date de début',
    'operations.info.operationEndDate.label': 'Date de fin',

    // OPERATIONS > CREATE

    'operations.operation.create.pageTitle': 'Création plan de vente',
    'operations.engagement.create.pageTitle': 'Création engagement',

    //* TOAST
    'operations.recommendations.import.success':
        'Bravo! les recommandations ont été importées avec succès',

    // OPERATION ERRORS
    'toast.apiErrors.OPERATION_DATES_MUST_BE_FILLED':
        'Vous devez saisir des dates de début et de fin',
    'toast.apiErrors.OPERATION_DATES_MUST_BE_IN_FUTURE':
        'Les dates de début et fin de cet élément doivent être dans le futur',
};
